/**
 * Migros / Yemeksepeti SQL emniyet ağı.
 *
 * SignalR push kaçarsa sipariş bir dakikalık yoklamayla listeye düşer ama
 * onNewOrder çağrılmazdı. Trendyol kalıbı (useTrendyolYemek.ts:915-927):
 * ilk başarılı yükleme sessizce tohumlanır; sonraki turlarda yeni ve
 * bildirilebilir siparişler için onNewOrder tetiklenir.
 *
 * Trendyol'dan fark: boş ilk yükleme de tohumlar (seeded=true). Böylece
 * ekran boş açılıp ilk dakikada gelen sipariş "görülmüş" sayılıp yutulmaz.
 */

export interface SafetyNetSeed {
  current: boolean;
}

export function applyNewOrderSafetyNet<T>(
  orders: T[],
  seenIds: Set<string>,
  seeded: SafetyNetSeed,
  getId: (order: T) => string,
  isNotifiable: (order: T) => boolean,
): T[] {
  if (!seeded.current) {
    for (const order of orders) {
      const id = getId(order);
      if (id) seenIds.add(id);
    }
    seeded.current = true;
    return [];
  }

  const missed: T[] = [];
  for (const order of orders) {
    const id = getId(order);
    if (!id || seenIds.has(id)) continue;
    seenIds.add(id);
    if (isNotifiable(order)) missed.push(order);
  }
  return missed;
}

export function resetNewOrderSafetyNet(seenIds: Set<string>, seeded: SafetyNetSeed): void {
  seenIds.clear();
  seeded.current = false;
}

export function markSafetyNetSeen(seenIds: Set<string>, id: string | number | null | undefined): void {
  const key = id == null ? '' : String(id);
  if (key) seenIds.add(key);
}

export function safetyNetOrderId(id?: string | number | null, fallback?: string | number | null): string {
  if (id != null && String(id) !== '' && String(id) !== '0') return String(id);
  if (fallback != null && String(fallback) !== '' && String(fallback) !== '0') return String(fallback);
  return '';
}
